import request from '@/utils/request';

/**
 * 后端PHP 将 `read_plan` 定义为训练营，
 * 故所有训练营接口都使用 Plan 开头
 * mark by Issa 2019/06/24 15:00
 */

export function getTrainingIndex() {
  return request({
    url: '/Plan/index_paging',
    silentRequest: true,
  });
}
export function getTrainingList(params) {
  return request({
    url: '/Plan/explore',
    params,
    silentRequest: true,
  });
}

export function isTrainingMember(id) {
  return request({
    url: '/Plan/isMember',
    params: {
      id,
    },
  });
}

export function getTrainingIntroduction(id) {
  return request({
    url: '/Plan/introduction',
    params: {
      id,
    },
  });
}

export function getJoinedTrainingDetail(id) {
  return request({
    url: '/Plan/joinedDetail',
    params: {
      id,
    },
  });
}

export function receiveCertificate(id) {
  return request({
    url: '/Plan/receiveCertificate',
    method: 'POST',
    data: {
      id,
    },
  });
}

export function getTrainingCertificateDetail(id) {
  return request({
    url: '/Plan/certificate',
    params: {
      id,
    },
  });
}

export function getTrainingLevelDetail(id, type) {
  return request({
    url: '/Level/detail',
    params: {
      id,
      type,
    },
  });
}

export function getTrainingTaskDetail(id, type) {
  return request({
    url: '/Level/taskDetail',
    params: {
      id,
      type,
    },
  });
}

export function isTrainingTaskFinish(id) {
  return request({
    url: '/Level/isFinish',
    params: {
      id,
    },
  });
}

export function getTrainingWorkShareDetail(id) {
  return request({
    url: '/Level/workShareDetail',
    params: {
      id,
    },
  });
}

export function getTrainingWorkDetail(id) {
  return request({
    url: '/Level/workDetail',
    params: {
      id,
    },
  });
}

export function submitTrainingWork(taskId, mediaId) {
  return request({
    url: '/Level/submitWork',
    method: 'POST',
    data: {
      taskId,
      mediaId,
    },
  });
}

export function getTrainingWorkNotify(id) {
  return request({
    url: '/Level/workNotify',
    params: {
      id,
    },
  });
}

export function getMyTrainingList(params, silentRequest = true) {
  return request({
    url: '/My/plan',
    params,
    silentRequest,
  });
}
